// extracted by mini-css-extract-plugin
export default {"container":"pages_container__3bt-s"};